// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-device-container{
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 2vh;
    left: 25%;
    width: 50%;
    border-radius: 10px;
}
.new-device-header{
    margin: 0px;
    padding: 15px;
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
}
.new-device-header h3{
    margin: 0px;
    color: white;
    font-weight: lighter;
}
.new-device-body{
    margin: 0px;
    padding: 45px;
    padding-top: 20px;
    padding-right: 55px;
    max-height: 60vh;
    overflow: none;
}
.new-device-body input,.new-device-body select{
    display: block;
    width: 96%;
    margin-top: 30px;
    padding: 12px 10px;
    outline: none;
    border: none;
    border-radius: 5px;
    background-color: rgb(222, 229, 233);
}
.new-device-body select{
    width: 99.5%;
}
.new-device-container-buttons{
    width: 100%;
    padding: 20px 50px;
    text-align: right;
    box-sizing: border-box;
}
.new-device-container-buttons button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}
.new-device-container-buttons button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Devices/NewDevice.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB","sourcesContent":[".new-device-container{\r\n    background-color: white;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    position: absolute;\r\n    top: 2vh;\r\n    left: 25%;\r\n    width: 50%;\r\n    border-radius: 10px;\r\n}\r\n.new-device-header{\r\n    margin: 0px;\r\n    padding: 15px;\r\n    width: 100%;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n}\r\n.new-device-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-weight: lighter;\r\n}\r\n.new-device-body{\r\n    margin: 0px;\r\n    padding: 45px;\r\n    padding-top: 20px;\r\n    padding-right: 55px;\r\n    max-height: 60vh;\r\n    overflow: none;\r\n}\r\n.new-device-body input,.new-device-body select{\r\n    display: block;\r\n    width: 96%;\r\n    margin-top: 30px;\r\n    padding: 12px 10px;\r\n    outline: none;\r\n    border: none;\r\n    border-radius: 5px;\r\n    background-color: rgb(222, 229, 233);\r\n}\r\n.new-device-body select{\r\n    width: 99.5%;\r\n}\r\n.new-device-container-buttons{\r\n    width: 100%;\r\n    padding: 20px 50px;\r\n    text-align: right;\r\n    box-sizing: border-box;\r\n}\r\n.new-device-container-buttons button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n}\r\n.new-device-container-buttons button:hover{\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
